<template>
  <v-container fluid pa-0 ma-0 text-xs-center>
    <v-layout
      class="white--text"
      height="100vh"
      justify-center
      row
      fill-height
      style="background-color: white; height: 100vh;"
    >
      <v-flex align-start pa-0 ma-0 md6>
        <v-img position="left left" height="100vh" src="/img/OgLoginBackground2.jpg"></v-img>
      </v-flex>
      <v-flex fill-height md6 style="padding: 5rem 3rem;" class="bg-logo-transparent">
        <v-container class="login-container">
          <v-layout column fill-height justify-center>
            <div class="og-logo-container">
              <v-img src="/img/LOGOTIPO_VERSION_1_OPENGES-03.png"></v-img>
            </div>
            <v-flex pt-5>
              <slot name="title"></slot>
            </v-flex>

            <v-flex md12>
              <slot name="content"></slot>
            </v-flex>
          </v-layout>
          <!--        <v-layout align-end justify-center row>-->
          <!--          <v-flex md12>-->
          <!--            <p style="color: #A19E9E; font-size: 14px">Mediante el envío de mis datos personales confirmo que he leído y acepto las condiciones de uso y la política de privacidad</p>-->
          <!--          </v-flex>-->
          <!--        </v-layout>-->
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {};
</script>
<style lang="scss">
.og-logo-container {
  max-width: 400px;
  min-width: 350px;
  margin: 0 auto;
}

.login-container {
  max-width: 600px;
  margin: 0 auto;
  .v-text-field--outline > .v-input__control > .v-input__slot {
    background: white !important;
  }
}

.bg-logo-transparent {
  background: linear-gradient(rgba(255, 255, 255, 0.85), rgba(255, 255, 255, 0.85)),
    url('/img/LOGOTIPO_VERSION_2_OPENGES-03.png') no-repeat;
  background-size: 200%; /* Amplía la imagen en 4 veces */
  background-position: -300px 300px; /* Desplaza la imagen 100px hacia abajo */
}
</style>
